import { render, staticRenderFns } from "./LevyCollectionProviderInvoicePanel.vue?vue&type=template&id=61931112&"
import script from "./LevyCollectionProviderInvoicePanel.vue?vue&type=script&lang=js&"
export * from "./LevyCollectionProviderInvoicePanel.vue?vue&type=script&lang=js&"
import style0 from "./LevyCollectionProviderInvoicePanel.vue?vue&type=style&index=0&id=61931112&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports